package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.model.Post
import com.example.readingnotes.domain.repository.PostRepository
import com.example.readingnotes.util.Result

class UpdatePostUseCase(
    private val postRepository: PostRepository,
) {
    suspend operator fun invoke(
        id: String,
        title: String? = null,
        contentMarkdown: String? = null,
        imageUrl: String? = null, // Keep for backward compatibility
        imageIds: List<String>? = null, // null means no change to imageIds
        status: String? = null,
        totpCode: String? = null,
    ): Result<Post> {
        if (title != null && title.isBlank()) {
            return Result.failure(IllegalArgumentException("タイトルを入力してください"))
        }
        return postRepository.updatePost(id, title, contentMarkdown, imageUrl, imageIds, status, totpCode)
    }
}
